import * as React from 'react';
import {NotionWrapper} from '@ux/notion-api';

const NotionBrandingStyle = () => (
	<NotionWrapper blockMap={{
	"blocks": [
		{
			"id": "7adbd680-541d-4e6e-97d1-f277bd1610c0",
			"type": "page",
			"properties": {
				"title": [
					[
						"Основа визуального языка"
					]
				]
			},
			"content": [
				"b9112d6a-87e7-451a-98fb-641852caeec5",
				"5ec5be76-efc5-432d-9606-c0f77b247c89",
				"0522268a-564d-4318-ade8-cf394edffe2f",
				"13c7b5a6-3d3f-4a2c-9f9c-a5c27947e9c1",
				"7d938352-4bbd-48d0-918f-cb73e1c8b251",
				"6693973d-75b4-4987-b828-383b805c5ec2",
				"4e50e9b5-2f15-417a-82b8-b4bdafa8d9fd",
				"5228d9df-7f2c-443f-a91b-6392af0a3a18",
				"1898ad26-cbdd-43fd-b3e7-979ba1899eb9",
				"c95da6c4-baa2-4834-a600-d1036c89e9aa",
				"97ef2640-d857-40d7-b7b1-a83b65d399be",
				"3da44b4f-5518-4b9e-aba7-64e099b31caf",
				"efb47dd7-4215-4349-a2a8-d0dba1d20394",
				"3d0201e7-4e3a-46e1-b86d-3fc2bb597bac",
				"6797d366-ba75-4483-8638-8471d71ccec9",
				"1b468bda-b99a-4ce4-a16d-503e1702d255",
				"876fc71d-a64d-49a2-a555-86642867018d",
				"f05c4617-500f-4e8b-bd0f-277495d93a2a",
				"91298f0a-e2e6-4079-99f5-f1734c9229c1",
				"db7e1e7c-f809-48e4-bd3c-4b01870dec50",
				"9fdf840a-4350-47af-85a9-7d5ce21031b4",
				"e76aa5c7-a260-4487-888c-215baeb805f5",
				"58cff005-a6d5-416c-b4be-c648679a84fa",
				"88ef040f-2f15-4f12-9468-2665bd677384",
				"e0765212-9b88-4f60-9dad-3adf6eba9830",
				"ba3b66d9-3b66-4ef6-b9ac-1bb37acbe9ae",
				"2e37095d-ac52-47ba-9b6a-5b60a999651f",
				"de25c06b-9c25-4cfd-863e-1861cd04257a",
				"71fbebdb-edb7-45c5-80be-bde2159471fa"
			],
			"format": {
				"copied_from_pointer": {
					"id": "53870173-c431-40ca-b265-f9d6366b933a",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "a7f0ba9f-a91a-4924-8447-b93845e6da1c",
			"parent_table": "block",
			"file_ids": [
				"57d7c821-a4e5-4906-922b-0e31ea61db8c"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a7f0ba9f-a91a-4924-8447-b93845e6da1c",
			"type": "page",
			"properties": {
				"title": [
					[
						"Paradigm"
					]
				]
			},
			"content": [
				"d4e0a1ac-e02e-4158-9d96-534ae9fa2c53",
				"b091b55a-a32c-4567-82d7-65c50636e3a7",
				"4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
				"7adbd680-541d-4e6e-97d1-f277bd1610c0",
				"ec15c567-4038-4c10-81bb-0a86aee56b08",
				"9a57d34b-41d2-40e4-8c4d-132953b7a175",
				"da552996-155b-442f-9ecf-0bdce521a35e",
				"1f51d543-236b-4b29-a278-4bed543f50b5",
				"5f304e57-18f8-4cd9-b80b-07951787740a",
				"f5097b73-1152-4e95-8919-54eed014af82",
				"94cd6ab9-c518-4094-829c-36d8a73e8010",
				"88cf99fd-dc9d-4649-8601-eb5198351e06",
				"d21336ae-ecfc-4130-a757-19109a89ad74",
				"e916c9a3-5983-4c34-bec3-187e417c593c",
				"cd7c41d2-ae59-4c69-b7d6-4254cf727ff5",
				"7ba8f4fe-6d71-4e1f-a1eb-1df9e3da0099",
				"31c9a6bd-328b-4869-aecd-fabd86f3cf15",
				"cb2b1b2c-b795-4abf-b11f-772b33e43908",
				"a47c1d35-578a-4679-8907-d8b13ab1bb65",
				"41e2749d-ddd3-4a06-b224-0ae6b4c9d436",
				"c3e7c6b7-650d-456d-8997-a4d049587d58",
				"7472c506-f9da-4f2e-85ba-59623551e747",
				"16b738c5-499f-42a0-baf4-cffb990a0b25",
				"51181f46-f9ad-4d25-b2c3-a59f7c7b8587",
				"e8ea6408-fc0d-4be8-8020-e982cc7c9b55",
				"3143e3ff-a6eb-4e48-8197-d96fceb48f9e",
				"20802187-e25a-4d38-af64-a363ffcace1d",
				"311c23ba-4ac6-48a0-bf3b-de8b115c363f",
				"aec03706-7113-42af-8724-4b446502d53a",
				"4836526c-ce6a-4bfd-8c2f-4bcb9a446e1e",
				"e0b8f319-a947-4c5d-8bdf-cd0ffeea5a6d",
				"aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
				"98a66dbd-731e-498f-9c5f-7790d1f555e0",
				"c7ec9e06-de22-4861-88e6-e6d45e0de285",
				"55690b50-0664-4442-9ded-4645f2f318e9"
			],
			"parent_id": "1fcd74a2-648f-4dfc-a4d8-abbb9a7bfb29",
			"parent_table": "team",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "b9112d6a-87e7-451a-98fb-641852caeec5",
			"type": "text",
			"parent_id": "7adbd680-541d-4e6e-97d1-f277bd1610c0",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "5ec5be76-efc5-432d-9606-c0f77b247c89",
			"type": "code",
			"properties": {
				"title": [
					[
						"<meta type=\"url\" value=\"/branding/style\"/>"
					]
				],
				"language": [
					[
						"JavaScript"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "8ef15538-1c34-431d-86c6-df43846c8667",
					"table": "block",
					"spaceId": "22066aad-9295-4afc-88d1-dae5d26fea31"
				}
			},
			"parent_id": "7adbd680-541d-4e6e-97d1-f277bd1610c0",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "0522268a-564d-4318-ade8-cf394edffe2f",
			"type": "text",
			"properties": {
				"title": [
					[
						"Визуальный язык — это способ коммуникации бренда в интерфейсе наших продуктов. Мы стремимся, чтобы приёмы визуального языка использовались сознательно, создавали дополнительную ценность, поддерживали прямую ассоциацию с брендом Mail.ru и не мешали использованию продукта."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "cabff90c-b6f6-455d-a366-c28a2c417aaa",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "7adbd680-541d-4e6e-97d1-f277bd1610c0",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "13c7b5a6-3d3f-4a2c-9f9c-a5c27947e9c1",
			"type": "header",
			"properties": {
				"title": [
					[
						"Структура интерфейса"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "308def0c-32c4-4d30-a763-66b4abce3e20",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "7adbd680-541d-4e6e-97d1-f277bd1610c0",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "7d938352-4bbd-48d0-918f-cb73e1c8b251",
			"type": "text",
			"properties": {
				"title": [
					[
						"Лэйаут и сетка помогают пользователю понять иерархию интерфейса. Помимо структурирующей, лэйаут выполняет и утилитарную функцию — стандартизирует основные компоненты продуктов, задаёт единый визуальный ритм. "
					],
					[
						"Подробнее",
						[
							[
								"a",
								"https://paradigm.mail.ru/grid",
								true
							]
						]
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "3007ac0a-1734-4fc7-ba9c-5aedee5a8f2d",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "7adbd680-541d-4e6e-97d1-f277bd1610c0",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "6693973d-75b4-4987-b828-383b805c5ec2",
			"type": "image",
			"properties": {
				"size": [
					[
						"96.2KB"
					]
				],
				"title": [
					[
						"image.png"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/9b4b8c68-d228-418d-979a-d8bf0d2f85fb/image.png"
					]
				]
			},
			"format": {
				"block_width": 1456,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/9b4b8c68-d228-418d-979a-d8bf0d2f85fb/image.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.5494505494505495,
				"block_preserve_scale": true
			},
			"parent_id": "7adbd680-541d-4e6e-97d1-f277bd1610c0",
			"parent_table": "block",
			"file_ids": [
				"9b4b8c68-d228-418d-979a-d8bf0d2f85fb"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/6693973d-75b4-4987-b828-383b805c5ec2.png"
		},
		{
			"id": "4e50e9b5-2f15-417a-82b8-b4bdafa8d9fd",
			"type": "header",
			"properties": {
				"title": [
					[
						"Типографика"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "48d7feec-920b-449d-87c5-7aab91cf3ea7",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "7adbd680-541d-4e6e-97d1-f277bd1610c0",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "5228d9df-7f2c-443f-a91b-6392af0a3a18",
			"type": "text",
			"properties": {
				"title": [
					[
						"Типографика и фирменный шрифт помогают считывать смысл сообщения и делают бренд узнаваемым. Ключевой элемент брендинга наших продуктов — корпоративный шрифт Mail Sans. "
					],
					[
						"Подробнее",
						[
							[
								"a",
								"https://paradigm.mail.ru/typography",
								true
							]
						]
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "01abb64a-dc80-4381-9dbe-cb082d7890aa",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "7adbd680-541d-4e6e-97d1-f277bd1610c0",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "1898ad26-cbdd-43fd-b3e7-979ba1899eb9",
			"type": "image",
			"properties": {
				"size": [
					[
						"137.4KB"
					]
				],
				"title": [
					[
						"image.png"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/76986207-0f7f-485e-841a-ab57c3fa4802/image.png"
					]
				]
			},
			"format": {
				"block_width": 1456,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/76986207-0f7f-485e-841a-ab57c3fa4802/image.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.5494505494505495,
				"block_preserve_scale": true
			},
			"parent_id": "7adbd680-541d-4e6e-97d1-f277bd1610c0",
			"parent_table": "block",
			"file_ids": [
				"76986207-0f7f-485e-841a-ab57c3fa4802"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/1898ad26-cbdd-43fd-b3e7-979ba1899eb9.png"
		},
		{
			"id": "c95da6c4-baa2-4834-a600-d1036c89e9aa",
			"type": "header",
			"properties": {
				"title": [
					[
						"Палитра"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "874c49b2-45af-403a-815b-6e3b10871afe",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "7adbd680-541d-4e6e-97d1-f277bd1610c0",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "97ef2640-d857-40d7-b7b1-a83b65d399be",
			"type": "text",
			"properties": {
				"title": [
					[
						"Палитра расширяет визуальную эстетику и объединяет дизайн продуктов. "
					],
					[
						"Подробнее",
						[
							[
								"a",
								"https://paradigm.mail.ru/palette",
								true
							]
						]
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "0276fe4e-d115-4015-8435-50693c95f8ec",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "7adbd680-541d-4e6e-97d1-f277bd1610c0",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "3da44b4f-5518-4b9e-aba7-64e099b31caf",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Палитра бренда"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "61844669-2ee7-466a-8007-3ac90f6159a3",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "7adbd680-541d-4e6e-97d1-f277bd1610c0",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "efb47dd7-4215-4349-a2a8-d0dba1d20394",
			"type": "text",
			"properties": {
				"title": [
					[
						"Палитра бренда крайне делает продукты Mail узнаваемыми  внутри и снаружи экосистемы."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "d454f1d1-339a-45f3-9b8a-faa4fe3832e9",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "7adbd680-541d-4e6e-97d1-f277bd1610c0",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "3d0201e7-4e3a-46e1-b86d-3fc2bb597bac",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Базовая палитра"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "d9da74b3-76af-4f62-9dad-261468e59cde",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "7adbd680-541d-4e6e-97d1-f277bd1610c0",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "6797d366-ba75-4483-8638-8471d71ccec9",
			"type": "text",
			"properties": {
				"title": [
					[
						"Палитра бренда содержит дополнительные цвета для состояний и оттенки серого. Мы стремимся использовать в продуктах минимум оттенков серого, поэтому они привязаны к семантике. "
					],
					[
						"Подробнее",
						[
							[
								"a",
								"https://paradigm.mail.ru/design_tokens",
								true
							]
						]
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "e1d352be-f54c-42a2-8a2e-5bf8c15a3a7a",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "7adbd680-541d-4e6e-97d1-f277bd1610c0",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "1b468bda-b99a-4ce4-a16d-503e1702d255",
			"type": "image",
			"properties": {
				"size": [
					[
						"191.0KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/21c1e771-2128-489a-ae5d-2fc294442a0c/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 1456,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/21c1e771-2128-489a-ae5d-2fc294442a0c/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.5494505494505495,
				"block_preserve_scale": true
			},
			"parent_id": "7adbd680-541d-4e6e-97d1-f277bd1610c0",
			"parent_table": "block",
			"file_ids": [
				"21c1e771-2128-489a-ae5d-2fc294442a0c"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/1b468bda-b99a-4ce4-a16d-503e1702d255.png"
		},
		{
			"id": "876fc71d-a64d-49a2-a555-86642867018d",
			"type": "header",
			"properties": {
				"title": [
					[
						"Иконографика"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "767d7399-5b08-4e06-8231-efcde2c42257",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "7adbd680-541d-4e6e-97d1-f277bd1610c0",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "f05c4617-500f-4e8b-bd0f-277495d93a2a",
			"type": "text",
			"properties": {
				"title": [
					[
						"Иконки и пиктограммы — важная часть визуального языка Mail и одна из важных точек контакта с брендом. В работе с иконками рекомендуется сохранять палитру бренда. "
					],
					[
						"Подробнее",
						[
							[
								"a",
								"https://paradigm.mail.ru/icon_style",
								true
							]
						]
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "16d10c73-b55a-4041-8ac8-1df6bab8b838",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "7adbd680-541d-4e6e-97d1-f277bd1610c0",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "91298f0a-e2e6-4079-99f5-f1734c9229c1",
			"type": "image",
			"properties": {
				"size": [
					[
						"166.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/9d895b47-6443-4df5-b46d-9ad621ed38e9/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 1456,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/9d895b47-6443-4df5-b46d-9ad621ed38e9/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.5631868131868132,
				"block_preserve_scale": true
			},
			"parent_id": "7adbd680-541d-4e6e-97d1-f277bd1610c0",
			"parent_table": "block",
			"file_ids": [
				"9d895b47-6443-4df5-b46d-9ad621ed38e9"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/91298f0a-e2e6-4079-99f5-f1734c9229c1.png"
		},
		{
			"id": "db7e1e7c-f809-48e4-bd3c-4b01870dec50",
			"type": "header",
			"properties": {
				"title": [
					[
						"Эффекты"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "312c9c96-02c9-42bf-bb3e-2e8bd03d352a",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "7adbd680-541d-4e6e-97d1-f277bd1610c0",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "9fdf840a-4350-47af-85a9-7d5ce21031b4",
			"type": "text",
			"properties": {
				"title": [
					[
						"Для определения параметров тени мы используем концепцию слоёв. Чем ниже находится слой объекта, тем менее интенсивную тень он получает."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "585aeb6b-4710-447c-896e-b1e9bea432cd",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "7adbd680-541d-4e6e-97d1-f277bd1610c0",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "e76aa5c7-a260-4487-888c-215baeb805f5",
			"type": "image",
			"properties": {
				"size": [
					[
						"146.9KB"
					]
				],
				"title": [
					[
						"image.png"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/6fd152c8-fc8f-45a2-a63a-b7815524b31e/image.png"
					]
				]
			},
			"format": {
				"block_width": 1456,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/6fd152c8-fc8f-45a2-a63a-b7815524b31e/image.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.5494505494505495,
				"block_preserve_scale": true
			},
			"parent_id": "7adbd680-541d-4e6e-97d1-f277bd1610c0",
			"parent_table": "block",
			"file_ids": [
				"6fd152c8-fc8f-45a2-a63a-b7815524b31e"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/e76aa5c7-a260-4487-888c-215baeb805f5.png"
		},
		{
			"id": "58cff005-a6d5-416c-b4be-c648679a84fa",
			"type": "header",
			"properties": {
				"title": [
					[
						"Тематизация"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "1f1576cc-d4c2-4258-a97c-da8f85ad94c1",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "7adbd680-541d-4e6e-97d1-f277bd1610c0",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "88ef040f-2f15-4f12-9468-2665bd677384",
			"type": "text",
			"properties": {
				"title": [
					[
						"Сервисные продукты могут поддерживать тёмную тему на десктопных и мобильных платформах. Для работы с тёмной темой мы используем концепцию слоёв: чем выше находится объект, тем он светлее."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "5bc3e0f3-1e9e-4dfe-9aac-bf98bd84e1b7",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "7adbd680-541d-4e6e-97d1-f277bd1610c0",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "e0765212-9b88-4f60-9dad-3adf6eba9830",
			"type": "image",
			"properties": {
				"size": [
					[
						"496.4KB"
					]
				],
				"title": [
					[
						"image.png"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/3bbd5944-6657-4e99-8cde-dbfe3bf9ba44/image.png"
					]
				]
			},
			"format": {
				"block_width": 1456,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/3bbd5944-6657-4e99-8cde-dbfe3bf9ba44/image.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.5494505494505495,
				"block_preserve_scale": true
			},
			"parent_id": "7adbd680-541d-4e6e-97d1-f277bd1610c0",
			"parent_table": "block",
			"file_ids": [
				"3bbd5944-6657-4e99-8cde-dbfe3bf9ba44"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/e0765212-9b88-4f60-9dad-3adf6eba9830.png"
		},
		{
			"id": "ba3b66d9-3b66-4ef6-b9ac-1bb37acbe9ae",
			"type": "header",
			"properties": {
				"title": [
					[
						"Доступность"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "a06ef32a-7e63-4419-96fc-eda23b3fd560",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "7adbd680-541d-4e6e-97d1-f277bd1610c0",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "2e37095d-ac52-47ba-9b6a-5b60a999651f",
			"type": "text",
			"properties": {
				"title": [
					[
						"Мы проверяем, чтобы константы визуального языка и их сочетания были доступны для максимального количества пользователей. Почти в каждом разделе гайдлайна вы найдёте рекомендации по доступности. "
					],
					[
						"Подробнее",
						[
							[
								"a",
								"https://paradigm.mail.ru/accessibility",
								true
							]
						]
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "1b6af45a-28f8-4614-9db8-7b43ae300334",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "7adbd680-541d-4e6e-97d1-f277bd1610c0",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "de25c06b-9c25-4cfd-863e-1861cd04257a",
			"type": "image",
			"properties": {
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/cd78a2ef-f9b9-4f2a-8168-41e3c051f9b5/accessibility.png"
					]
				]
			},
			"format": {
				"block_width": 2184,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/cd78a2ef-f9b9-4f2a-8168-41e3c051f9b5/accessibility.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.5631868131868132,
				"copied_from_pointer": {
					"id": "e9ba147f-be28-4b17-bd54-1f42498d8afe",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				},
				"block_preserve_scale": true
			},
			"parent_id": "7adbd680-541d-4e6e-97d1-f277bd1610c0",
			"parent_table": "block",
			"file_ids": [
				"cd78a2ef-f9b9-4f2a-8168-41e3c051f9b5"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/de25c06b-9c25-4cfd-863e-1861cd04257a.png"
		},
		{
			"id": "71fbebdb-edb7-45c5-80be-bde2159471fa",
			"type": "text",
			"format": {
				"copied_from_pointer": {
					"id": "86897e0e-8cb3-4c09-a5e3-37a431182aaa",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "7adbd680-541d-4e6e-97d1-f277bd1610c0",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		}
	],
	"headers": [
		{
			"title": "Структура интерфейса",
			"id": "13c7b5a6-3d3f-4a2c-9f9c-a5c27947e9c1"
		},
		{
			"title": "Типографика",
			"id": "4e50e9b5-2f15-417a-82b8-b4bdafa8d9fd"
		},
		{
			"title": "Палитра",
			"id": "c95da6c4-baa2-4834-a600-d1036c89e9aa"
		},
		{
			"title": "Иконографика",
			"id": "876fc71d-a64d-49a2-a555-86642867018d"
		},
		{
			"title": "Эффекты",
			"id": "db7e1e7c-f809-48e4-bd3c-4b01870dec50"
		},
		{
			"title": "Тематизация",
			"id": "58cff005-a6d5-416c-b4be-c648679a84fa"
		},
		{
			"title": "Доступность",
			"id": "ba3b66d9-3b66-4ef6-b9ac-1bb37acbe9ae"
		}
	]
}} />
);

export default NotionBrandingStyle;
